"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropTarget = exports.Draggable = void 0;
var _react = _interopRequireDefault(require("react"));
require("./drag-drop.scss");
var _mobileDragDropPolyfill = _interopRequireDefault(require("./mobile-drag-drop-polyfill"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const DRAGGABLE_CLASS = "donation-encourager__draggable";
const Draggable = _ref => {
  let {
    children,
    dragData,
    onDragStart,
    onDragEnd
  } = _ref;
  (0, _mobileDragDropPolyfill.default)(DRAGGABLE_CLASS);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: DRAGGABLE_CLASS,
    draggable: true,
    onDragStart: e => {
      if (typeof onDragStart === "function") onDragStart(e);
      e.dataTransfer.setData("text/plain", JSON.stringify(dragData));
      e.currentTarget.style.cursor = "grabbing";
    },
    onDragEnd: e => {
      e.currentTarget.style.cursor = "";
      if (typeof onDragEnd === "function") onDragEnd(e);
    }
  }, children);
};
exports.Draggable = Draggable;
const DropTarget = _ref2 => {
  let {
    children,
    onDrop,
    onDropLeft,
    onDropRight
  } = _ref2;
  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    const data = JSON.parse(e.dataTransfer.getData("text/plain"));
    const side = getDropSide(e);
    if (side === "left" && typeof onDropLeft === "function") onDropLeft(data);
    if (side === "right" && typeof onDropRight === "function") onDropRight(data);
    if (typeof onDrop === "function") onDrop(data);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "donation-encourager__drop-target" // https://github.com/timruffles/mobile-drag-drop#polyfill-requires-dragenter-listener
    ,

    onDragEnter: e => e.preventDefault(),
    onDragOver: e => e.preventDefault(),
    onDrop: handleDrop
  }, children);
};
exports.DropTarget = DropTarget;
function getDropSide(e) {
  const dropX = e.clientX;
  const rect = e.target.getBoundingClientRect();
  const targetCenter = rect.x + rect.width / 2;
  return dropX >= targetCenter ? "right" : "left";
}